import { render, staticRenderFns } from "./runWateUpdRecord.vue?vue&type=template&id=89f22156"
import script from "./runWateUpdRecord.vue?vue&type=script&lang=js"
export * from "./runWateUpdRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports